import { useAuth } from "../../context/AuthContext";
import { dictionary } from "../../utils/dictionary";

const FIELD_LABELS: Record<string, string> = {
  country: "País",
  country_code: "País",
  shopify_order_id: "ID de orden Shopify",
  shopify_order_name: "Pedido Shopify",
  shopify_financial_status: "Estado de pago Shopify",
  shopify_fulfillment_status: "Estado de entrega Shopify",
  shopify_checkout_token: "Token de checkout Shopify",
};

const normalizeKey = (key: unknown) => String(key ?? "").trim().toLowerCase();

const formatLabel = (key: unknown) => {
  const normalizedKey = normalizeKey(key);
  if (FIELD_LABELS[normalizedKey]) return FIELD_LABELS[normalizedKey];

  return String(key ?? "")
    .replace(/_/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
};

const formatValue = (value: unknown) => {
  if (value == null) return "";
  if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  return JSON.stringify(value);
};

export const CustomerFieldsCard = ({ customFields }: { customFields: any[] }) => {
  const { language } = useAuth();
  const fields = (customFields || [])
    .map((field) => ({
      key: field?.key,
      label: formatLabel(field?.key),
      value: formatValue(field?.value),
    }))
    .filter((field) => field.key && field.value);

  if (!fields.length) return null;

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm">
      <h2 className="text-lg font-semibold mb-4">{dictionary["additional-information"][language]}</h2>
      
      <div className="space-y-3">
        {fields.map((field, index) => {
          const isLongValue = field.value.length > 32 || field.value.includes("gid://");

          return (
            <div key={`${field.key}-${index}`} className="rounded-lg border border-gray-100 bg-gray-50 px-3 py-2">
              <p className="text-xs font-semibold uppercase text-gray-500">{field.label}</p>
              <p
                className={`mt-1 text-sm text-gray-800 ${isLongValue ? "break-all font-mono leading-5" : "break-words"}`}
                title={field.value}
              >
                {field.value}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
